import useBackButton from "hooks/useBackButton";
import { useHistory } from "react-router-dom";
// import { ReactComponent as IconAngleLeft } from "assets/images/icons/project-icons/angle-left.svg";
import { ReactComponent as IconArrowLeft } from "assets/images/icons/project-icons/arrow-left.svg";
import Maybe from "components/__new/common/Maybe";


export const BackButtonPage = (props) => {
    const {goBack} = useBackButton();
    const history = useHistory();

    const goto = () => {
        if (props.link === undefined){
            goBack();
        }
        else{
            history.push(props.link);
        }
    }

    return ( 
        <>
            {/*
            <div onClick={() => goto()} className="h-8 pr-2 mr-1 flex cursor-pointer">
                <Maybe condition={props.children === undefined}>
                    <IconAngleLeft style={{ height: "16px" }} className="w-8 m-auto" />
                </Maybe>
                <Maybe condition={props.children !== undefined}>
                    {props.children}
                </Maybe>
            </div>
            */}
            <div onClick={() => goto()} className="w-10 h-10 pr-2 mr-4 flex items-center bg-[#ECECEC] hover:bg-gray-300 rounded-md cursor-pointer">
                <Maybe condition={props.children === undefined}>
                    <IconArrowLeft className="relative left-2" />
                </Maybe>
                <Maybe condition={props.children !== undefined}>
                    {props.children}
                </Maybe>
            </div>
        </>
    )
}
